import axios from "axios";

const keys = require("../config/keys");

export const payment = (obj, memberdata) => async (dispatch) => {
  //let wurl = "https://apiqa.controla.in/payment/payCOVIDDonation";insert

  memberdata.paymentid = "";
  memberdata.status = "";
  // let murl = keys.ServicePath + "/api/member/insert";
  // axios({
  //   method: "post",
  //   url: murl,
  //   data: memberdata,
  // })
  //   .then(async (res) => {
  //     console.log("ress--", res);
  //   })
  //   .catch((e) => {
  //     console.log("errrr", e);
  //   });

  let wurl = `${keys.ServicePath}/api/payment/pay`;
  await axios({
    method: "post",
    url: wurl,
    data: obj,
  })
    .then((res) => {
      if (res.data) {
        try {
          var obj = {};
          obj.hash = res.data.params.hash;
          obj.amount = parseFloat(res.data.params.amount);
          obj = res.data.params;
          //console.log(res.data,memberdata);
          launchBOLT(obj, res.data, memberdata);
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch((e) => {
      console.log("catch error", JSON.stringify(e));
    });
  //console.log(data);
};

function launchBOLT(payParams, otherdata, member) {
  let bolt = window.bolt;
  //let a = payParams;
  //console.log("LAUNCH",member);
  //console.log(bolt);
  sessionStorage.setItem("paymentParams", payParams);

  bolt.launch(
    {
      hash: payParams.hash,
      txnid: payParams.txnid.toString(),
      key: payParams.key,
      amount: payParams.amount,
      firstname: payParams.firstname,
      email: payParams.email,
      phone: payParams.phone,
      productinfo: payParams.productinfo,
      surl: payParams.surl,
      furl: payParams.furl,
      lastname: payParams.lastname,
      curl: payParams.curl,
      address1: payParams.address1,
      address2: payParams.address2,
      city: payParams.city,
      state: payParams.state,
      country: payParams.country,
      zipcode: payParams.zipcode,
      udf1: payParams.udf1,
      udf2: payParams.udf2,
      udf3: payParams.udf3,
      udf4: payParams.udf4,
      // udf5: payParams.vpc_MerchTxnRef,
      udf5: payParams.udf5,
      pg: payParams.pg,
    },
    {
      responseHandler: async function (BOLT) {
        console.log(BOLT.response);
        if (BOLT.response.txnStatus.toUpperCase() !== "CANCEL") {
          let GCNO = "";
          // let wurl = "https://localhost:5000/payment/PaymentReceiptCovid";
          if (BOLT.response.status.toUpperCase() === "SUCCESS") {
            //console.log(member);
            member.paymentid = BOLT.response.payuMoneyId;
            member.status = BOLT.response.status;
            let murl = keys.ServicePath + "/api/member/insert";
            axios({
              method: "post",
              url: murl,
              data: member,
            }).then(async (res) => {
              console.log("SUCCESS", res);
              GCNO = res.data.code || "";

              let wurl = `${keys.ServicePath}/api/payment/PaymentReceipt`;
              await axios({
                method: "post",
                url: wurl,
                data: BOLT.response,
              }).then((res1) => {
                console.log(res1);
                // var queryString = "provider=PAYU&";

                // Object.entries(BOLT.response).forEach(([key, value]) => {
                //   queryString += key + "=" + value + "&";
                // });
                // queryString = queryString.slice(0, -1);
                //console.log("RECEIPT", GCNO)
                window.location.href = res1.data + "&code=" + GCNO;
              });
            });
          } else {
            console.log("IN ERROR", BOLT.response);
            member.paymentid = BOLT.response.payuMoneyId;
            member.status = BOLT.response.status;
            let murl = keys.ServicePath + "/api/member/insert";
            axios({
              method: "post",
              url: murl,
              data: member,
            }).then(async (res) => {
              //console.log("MEMBER", res.data);

              let wurl = `${keys.ServicePath}/api/payment/PaymentReceipt`;
              await axios({
                method: "post",
                url: wurl,
                data: BOLT.response,
              }).then((res1) => {
                console.log(res1);
                // var queryString = "provider=PAYU&";

                // Object.entries(BOLT.response).forEach(([key, value]) => {
                //   queryString += key + "=" + value + "&";
                // });
                // queryString = queryString.slice(0, -1);
                //console.log("RECEIPT", GCNO)
                window.location.href = res1.data;
              });
            });
          }
        } else if (BOLT.response.txnStatus.toUpperCase() === "CANCEL") {
        }
      },
      catchException: function (BOLT) {
        console.log(BOLT);

        member.paymentid = "";
        member.status = "";
        let murl = keys.ServicePath + "/api/member/insert";
        axios({
          method: "post",
          url: murl,
          data: member,
        }).then(async (res) => {});
        // alert(BOLT);
      },
    }
  );
}
